import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from '../Tabs/Tabs';
import CustomerPresenterTabContent from "./CustomerPresenterTabContent";

class CustomerPresenter extends React.Component {

	constructor(props) {
		super(props);
		var self = this;

    this.buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      }
    ]

    this.state = {
      active_tab: this.props.active_tab || 'general',
      customer: this.props.customer.customer ? this.props.customer.customer : null,
      field_groups: this.props.field_groups ? this.props.field_groups : [],
      field_group_names: this.props.field_group_names ? this.props.field_group_names : [],
      loading: false,
      removedCards: [],
      note_count: this.props.note_count || null,
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null,
      },
      file_group: this.props.file_group,
      answers: this.props.answers
    };

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this);
	}

  /*******************
  * Render functions *
  ********************/

	render() {
		return (
			<div className="guest-type-presenter" ref="root">
        <Tabs tabs={this.tabs()} />
				<div className="panel panel-form">
  				<ModalButtons loading={this.state.loading} buttons={this.buttons} />
          <CustomerPresenterTabContent {...this.props}  {...this.state} />
  			  <LoadingSpinner show={this.state.loading} />
        </div>
			</div>
		);
	}

  /******************
  * Change handlers *
  *******************/

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab});
  }

  onChange(value, name) {
    if(this.name === 'translations') {
      this.setState({
        [name]: [value],
      });
    } else {
      this.setState({
        [name]: value,
      });
    };
  };

  tabs() {
    if (this.props.historical_version === true) {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: this.state.errors && this.state.errors.general_tab_header_errors ? this.state.errors.general_tab_header_errors.length : null,
          },
        ]
      );
    } else {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: this.state.errors && this.state.errors.general_tab_header_errors ? this.state.errors.general_tab_header_errors.length : null,
          },
          {
            tabName: I18n.t('cards'),
            targetName: 'cards',
            classes: this.state.active_tab === 'cards' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: this.state.errors && this.state.errors.cards_header_errors ? this.state.errors.cards_header_errors.length : null,
          },
          {
            tabName: I18n.t('payments'),
            targetName: 'payments',
            classes: this.state.active_tab === 'payments' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('reservations'),
            targetName: 'reservations',
            classes: this.state.active_tab === 'reservations' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('emails'),
            targetName: 'emails',
            classes: this.state.active_tab === 'emails' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('text_messages'),
            targetName: 'message_logs',
            classes: this.state.active_tab === 'message_logs' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('notes'),
            targetName: 'notes',
            classes: this.state.active_tab === 'notes' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('history'),
            targetName: 'history',
            classes: this.state.active_tab === 'history' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      );
    };
  };

  renderAdditionalCustomerFields() {
    var customerFields  = this.props.additional_customer_fields.map((customer_field, idx) => {
      return (
        <div className="col-sm-3" key={idx}>
          <div className="form-group">
            <strong>{`${customer_field.field}${customer_field.required === true ? '*' : ""}`}</strong>
            : {this.props.customer.customer_answer}
          </div>
        </div>
      )
    });
    return (
      <div className="row">
        {customerFields}
      </div>
    );
  }

  onChangeRevertVersion() {
    var self = this
    self.setState({ loading: true });
    $.ajax({
      type: 'POST',
      url: `/admin/customers/${self.state.customer.id}/version/${self.state.version.id}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger('customerSaved');
      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('record_reverted_successfully'));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    })
  }
}

export default CustomerPresenter
